import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { isLinkValid } from "~/features/ui/link/utils";
import { Icon } from "~/features/ui/icon";
import { HoverTooltip } from "~/features/ui/hover-tooltip";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
const fragment = graphql(`
  fragment NavAdditionalLinkV2 on navAdditionalLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function NavAdditionalLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link,
    ...rest
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  if (!isLinkValid(link)) {
    return null;
  }

  // Same convention as useLinkIcon: a link that opens in a new tab is external.
  const isExternal = Boolean((link as {
    newWindow?: boolean;
  }).newWindow);
  const linkEl = <_StyledLink {...link} {...rest} $_css={[{
    "position": "relative",
    "display": "inline-flex",
    "height": "100%",
    "width": "100%",
    "alignItems": "center",
    "justifyContent": "center",
    "gap": "0.8rem",
    "paddingLeft": "5.2rem",
    "paddingRight": "5.2rem"
  }, {
    "&::before": {
      "content": "var(--tw-content)",
      "position": "absolute",
      "left": "0",
      "right": "0",
      "top": "0",
      "height": "0.4rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
      "opacity": "0",
      "transitionProperty": "opacity",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      "--tw-content": "''"
    }
  }, {
    "@media (hover: hover)": {
      "&:hover::before": {
        "content": "var(--tw-content)",
        "opacity": "1"
      }
    }
  }]}>
      {(link as {
      text?: string;
    }).text}
      {isExternal && <Icon icon={ArrowTopRight} size="16" />}
    </_StyledLink>;
  if (!isExternal) {
    return linkEl;
  }

  // Hovering anywhere on the link shows the tooltip; clicks still reach the <a>.
  return <HoverTooltip content="Open external store">{linkEl}</HoverTooltip>;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "nav-additional-link___StyledLink",
  componentId: "sc-1ntlv6f-0"
})(["", ""], p => p.$_css);